import React from 'react';
import styled from 'styled-components';

import {FENCE_TYPE_GATE, FENCE_TYPE_GATE_SELF_SUPPORTING} from 'App';
import {getTopFrame} from 'Design/Design';

import Automation from '../../Automation';
import Rods from '../../Rods';

const TopBar = styled.div`
  background-size: contain;
  background-repeat: repeat;
  width: 100%;
  background-image: url('img/gateSelfSupporting/top.png');
  z-index: 999;
`;

const BottomBar = styled.div`
  background-size: contain;
  margin-top: -4.5px;
  height: 42px;
  width: 100%;
  z-index: 9;
  background-image: url('img/gateSelfSupporting/bottom.png');
`;

const Container = styled.div`
  width: 75%;
  margin-left: -13px;
`;

const Body = ({ design, scale, projectType }) => (
  <Container>
    <TopBar
      style={{
        height: `${getTopFrame(FENCE_TYPE_GATE, FENCE_TYPE_GATE_SELF_SUPPORTING, design.width) / scale}px`,
      }}
    />
    <Rods
      style={{ width: 'calc(100% + 30px)' }}
      design={design}
      scale={scale}
      projectType={projectType}
      fenceType="gateSelfSupporting"
    />
    <BottomBar />
    {/* <Automation/> */}
  </Container>
);

export default Body;
